import { createContext } from 'react';

/** create global state using react context. This will be used to check the login status **/
const LoginContext = createContext({});
export default LoginContext;
